import { Button, Drawer, Space } from "antd";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsCheckSquare } from "react-icons/bs";
import Moment from "react-moment";
import { formatNumber } from "../../../../utils/formatNumber";
import ConfirmPanel from "./ConfirmPanel";

export default function DetailsPanel({
  setVisible,
  isVisible,
  selected,
  refetch,
}: any) {
  const [confirmModal, setConfirmModal] = useState(false);
  return (
    <Drawer
      title={`${selected?.vehicle} BOOKING`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="flex flex-col">
        <div className="flex text-black font-bold text-lg mb-4">
          VEHICLE:
          {selected?.title ? selected?.title : selected?.vehicle}
        </div>
        <div className="flex">
          <div className="flex">
            <div>
              <div className="mb-4">
                <span className="mt-2 text-black font-bold">
                  Customer Details:{" "}
                </span>
                <div className="flex">
                  <div className="flex flex-col ml-2">
                    <span>- Name: {selected?.customer_name}</span>
                    <span>- Mobile: {selected?.customer_mobile}</span>
                    <span>- Email: {selected?.customer_email}</span>
                    <span>- Address: {selected?.customer_address}</span>
                    <span>- Account: {selected?.customer_id}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-2">
            <div className="flex text-black font-bold text-sm">
              Vehicle Details : -
            </div>

            <div className="ml-2">
              <span className="">- Type : </span>
              {selected?.description}
            </div>

            <div className="ml-2">
              <span className="">- Model : </span>
              {selected?.model}
            </div>
            <div className="ml-2">
              <span className="">- VIN : </span>
              {selected?.vehicle_vin}
            </div>
            <div className="ml-2">
              <span className="">- Engine No : </span>
              {selected?.vehicle_engine}
            </div>
            <div className="ml-2">
              <span className="">- Mileage : </span>
              <span className="text-gray-700">
                {selected?.mileage === null || selected?.mileage === ""
                  ? "-"
                  : formatNumber(Number(selected?.mileage))}{" "}
                Km
              </span>
            </div>
          </div>
          <div className="mx-2">
            <div className="flex text-black font-bold text-sm">
              Booking Details : -
            </div>
            <div className="ml-2">
              <span className="">- Requested : </span>
              <Moment format="Do MMM, YYYY">{selected?.createdAt}</Moment>
            </div>
            <div className="flex ml-2">
              <span className="w-16">- Center : </span>
              {selected?.site?.name}
            </div>
            <div className="flex ml-2">
              <span className="w-16">- Date: </span>
              <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
            </div>
            <div className="flex ml-2">
              <span className="w-16">- Time : </span>
              <Moment format="HH:mm A">{selected?.slottime?.starttime}</Moment>
              <div className="mx-2">-</div>
              <Moment format="HH:mm A">{selected?.slottime?.endtime}</Moment>
            </div>
            <div className="flex ml-2">
              <span className="w-16">- WIP : </span>
              {selected?.wip}
            </div>
          </div>
        </div>
        <div className="flex flex-col mt-2">
          <span className="italic"> Additional Remarks : </span>
          {selected?.customer_comments ? (
            <div>{selected?.customer_comments}</div>
          ) : (
            <div className="text-gray-500 py-2"> No Remarks</div>
          )}
        </div>

        <div className="mt-4">
          <div className="font-bold mb-2">Registartion Card </div>
          {selected?.attachment ? (
            <div className="border p-1">
              <img src={`data:${selected?.attachment}`} />
            </div>
          ) : (
            <span className="text-gray-50 py-2">No Document</span>
          )}
        </div>

        <div className="border-t pt-4">
          {!selected?.is_confirmed ? (
            <button
              onClick={() => {
                setConfirmModal(true);
              }}
              className="flex justify-center items-center text-red-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
            >
              <span className="ml-1">Unconfirmed </span>
            </button>
          ) : (
            <button className="flex justify-center items-center ml-1 text-green-700 border rounded-md p-2 bg-green-100 hover:bg-green-200 cursor-not-allowed">
              <BsCheckSquare /> <span className="ml-1">Confirmed</span>
            </button>
          )}
        </div>
        <ConfirmPanel
          selected={selected}
          isVisible={confirmModal}
          setConfirmModal={setConfirmModal}
          refetch={refetch}
        />
      </div>
    </Drawer>
  );
}
